module.exports = __webpack_public_path__ + "static/media/health-practitioner.0e6a41fc.svg";